// login.js
import AWS from 'aws-sdk';
import config from '../config';
import { constructAuthdetails, constructUser } from './helpers';
import { logIn as googleTagLogIn } from '../google';

export const async_login = (email, password, remember) => {
  email = email.toLowerCase();
  const authdetails = constructAuthdetails(email, password);
  const user = constructUser(email);
  return new Promise((resolve, reject) => {
    user.authenticateUser(authdetails, {
      onSuccess: function(result) {
        AWS.config.region = config.region;
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: config.IdentityPoolId,
          Logins: {
            [config.login]: result.getIdToken().getJwtToken()
          }
        });

        // refreshes credentials using AWS.CognitoIdentity.getCredentialsForIdentity()
        AWS.config.credentials.refresh(error => {
          if (!error) {
            // If requested, remember the device
            if (remember) {
              user.setDeviceStatusRemembered({
                onSuccess: function(result) {
                  return;
                },
                onFailure: function(error) {
                  return;
                }
              });
            }
            // We are finally logged in and handsome
            googleTagLogIn();
            resolve(user);
          } else {
            console.log(error);
            reject(error);
          }
        });
      },
      onFailure: function(error) {
        reject(error);
      }
    });
  });
};



// WEBPACK FOOTER //
// ./src/utils/user/login.js